import * as React from 'react';

function SvgMagnifyingGlass(props) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M22.35 23.72l-7.4-7.3a15 15 0 001.37-1.35l7.4 7.28a.96.96 0 01-1.37 1.37zM9.2 18.42A9.2 9.2 0 119.2 0a9.2 9.2 0 010 18.43zm.02-16.7a7.5 7.5 0 100 15 7.5 7.5 0 000-15z" />
    </svg>
  );
}

export default SvgMagnifyingGlass;
